var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 105,
    viewBox: "0 0 51 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_165_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5884 1.43113C30.8721 9.22049 34.0467 19.5266 28.3308 29.9719C25.2848 35.5393 20.4182 39.2334 19.5491 45.9256C17.5585 61.2735 32.1123 69.2037 31.5318 83.6738C31.479 84.974 31.1921 86.3854 31.0387 87.6823H30.5472C30.5258 87.2828 30.5934 86.8701 30.5291 86.4722C28.5336 74.0145 17.9873 70.2222 11.2456 61.1818C5.38119 53.3187 1.82727 43.8641 5.66815 34.2457C8.00499 28.3902 12.7661 23.879 16.0512 18.5769C19.521 12.9735 21.81 6.72829 20.5204 0.0507589C20.8816 -0.283281 22.2702 1.13148 22.5884 1.43113Z",
    fill: "#C9A662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9851 38.7159C35.902 47.866 44.8108 54.5975 48.5824 62.4688C54.4451 74.7087 49.0425 88.144 38.8441 96.0153C36.6425 97.7149 33.9033 99.4359 31.2053 100.107C31.0337 99.0003 32.1634 98.2651 32.7884 97.3498C37.8728 89.8961 38.7089 77.7626 34.9868 69.6162C33.6147 66.6164 31.4032 64.5041 29.7622 61.7335C27.1863 57.3845 26.1028 53.1222 26.4409 48.0379C26.8383 42.053 30.7204 37.1963 34.6586 32.993L34.9868 33.1584C35.117 34.9465 34.8103 36.9589 34.9868 38.7175L34.9851 38.7159Z",
    fill: "#C9A662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0662 58.9073C5.2608 61.8187 6.56362 64.604 8.22102 66.9685C14.1761 75.4619 28.1889 81.3404 26.0599 93.6C25.3442 97.7182 22.5192 101.506 19.1895 103.934C18.9257 104.126 17.7993 104.933 17.608 104.98C16.7455 105.196 17.3804 103.512 17.4018 102.974C17.6591 96.5785 11.7865 93.8391 7.69494 90.217C4.91118 87.7527 1.18409 83.3627 0.372711 79.6784C-0.778396 74.45 0.794894 63.7656 4.27295 59.5066C4.47745 59.2561 4.68359 58.8631 5.0662 58.9073Z",
    fill: "#C9A662"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_165_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 105,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay1);
export default __webpack_public_path__ + "static/media/play1.7cb65baa1113ad3ed0c4e022e595c71c.svg";
export { ForwardRef as ReactComponent };